import { AlertCircle, AlertTriangle, Info } from 'lucide-react';

const icons = {
  danger: AlertCircle,
  warning: AlertTriangle,
  info: Info,
};

export function AIInsightsPanel({ insights }) {
  const list = insights?.insights || [];
  if (!list.length) return null;

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="mb-3 text-sm font-semibold text-slate-800">Insights</h3>
      <ul className="space-y-2">
        {list.map((item, i) => {
          const Icon = icons[item.severity] || Info;
          const border =
            item.severity === 'danger'
              ? 'border-red-200 bg-red-50'
              : item.severity === 'warning'
                ? 'border-amber-200 bg-amber-50'
                : 'border-blue-200 bg-blue-50';
          return (
            <li
              key={`${item.type}-${i}`}
              className={`flex gap-2 rounded-lg border p-3 text-sm ${border}`}
            >
              <Icon className="mt-0.5 h-4 w-4 shrink-0" />
              <div>
                <p className="font-semibold text-slate-900">{item.title}</p>
                <p className="mt-0.5 text-slate-700">{item.message}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
